declare let grecaptcha: any;

import { UiActions } from './uiActions';

export class Recaptcha {
  helperFunc = new UiActions();

  c  = {
    recapId: "recapId",
    clsRecap: "app-jqfs-recaptcha",
    clsRecapWrap: "app-recaptcha-wrapper"
  };
  widgetId1 = "";

  constructor() { }

  /*
    Initialize Recaptcha and create a Recapcha Checkbox below the Formfields 
  */
  init(wrapper: JQuery) {
    if(!this.recaptchaEnabled(wrapper)) {
      return;
    }

    const recap = wrapper.find("." + this.c.clsRecap);
    const recapId = recap.data('id');

    grecaptcha.ready(() => {
      // console.log("Recaptcha element", recap);
      // console.log("Recaptcha sitekey", recap.data("sitekey"));
      // console.log("Recaptcha sitekey", recap.data("sitekeyv2"));
      
      // Trigger a "page view" action (not necessary, but delivers more context for recaptcha v3 verification)
      // grecaptcha.execute(recap.data("sitekey"), {action: 'contact_form_visit'});
      this.widgetId1 = grecaptcha.render(recapId, {
        'sitekey' : recap.data("sitekeyv2")
      });
    });
    
  }

  async checkV2(wrapper: JQuery) {
    if(!this.recaptchaEnabled(wrapper)) {
      return true;
    }

    const recap = wrapper.find("." + this.c.clsRecap);
    const recapId = recap.data('id');
    console.log("Validating recaptcha", recap);

    return await grecaptcha.getResponse(this.widgetId1); // null if failed, something cryptic if ok
  }

  /* 
    Checks if a recaptcha is implemented in the current Form
  */
  async check(wrapper: JQuery) {
    if(!this.recaptchaEnabled(wrapper)) {
      return true;
    }

    const recap = wrapper.find("." + this.c.clsRecap);
    console.log("Validating recaptcha", recap);

    // return google response for the recap (returns a promise)
    return await grecaptcha.execute(recap.data("sitekey"), {action: 'contact_form_send'}); // null if failed, something cryptic if ok
  }

  recaptchaEnabled(wrapper: JQuery) {
    const recap = wrapper.find("." + this.c.clsRecap);
    // if no recaptcha found, probably ok
    if(recap.length === 0) {
      return false;
    }

    // if many found, probably not ok
    if(recap.length !== 1) {
      throw "Multiple re-captcha instances found in the same form";
    }
    return true;
  }
}